export default __webpack_public_path__ + "static/media/gyroX.eaba0689.svg";